// Demo only: the fictional account staff "voir comme…" (docs/engineering/roles.md), kept per client for the browser session.

/** "Voir comme…" in a demo: which fictional account staff act as (none: themselves, as a director). */
export type DemoPersona = 'manager' | 'owner' | 'occupant';
const personaKey = (tenantId: string) => `demo-persona:${tenantId}`;
export function demoPersonaOf(tenantId: string): DemoPersona | null {
  try {
    const v = sessionStorage.getItem(personaKey(tenantId));
    return v === 'manager' || v === 'owner' || v === 'occupant' ? v : null;
  } catch {
    return null;
  }
}
export function storePersona(tenantId: string, persona: DemoPersona | null) {
  try {
    if (persona) sessionStorage.setItem(personaKey(tenantId), persona);
    else sessionStorage.removeItem(personaKey(tenantId));
  } catch {
    /* private mode: the choice lasts until the page reloads */
  }
}

